import React, { useState } from 'react';
import api from '../utils/api';

export default function LoginPage() {
  const [email, setEmail] = useState('');
  const [token, setToken] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  async function handleLogin(e) {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const { data } = await api.post('/auth/login', {
        email: email.trim(),
        me_token: token.trim(),
      });
      localStorage.setItem('dock_token', data.access_token);
      localStorage.setItem('dock_user', JSON.stringify({
        name: data.technician_name,
        email: data.technician_email,
      }));
      window.location.href = '/';
    } catch (err) {
      setError(err.response?.data?.detail || 'Login failed. Check your email and ME token.');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={styles.logo}>
          <span style={styles.logoText}>DOCK</span>
          <span style={styles.logoSub}>Documentation Kit</span>
        </div>
        <form onSubmit={handleLogin}>
          <label style={styles.label}>Email</label>
          <input
            style={styles.input}
            type="email"
            value={email}
            onChange={e => setEmail(e.target.value)}
            placeholder="your.email@ricoh.pt"
            required
          />
          <label style={styles.label}>ManageEngine API Token</label>
          <input
            style={styles.input}
            type="password"
            value={token}
            onChange={e => setToken(e.target.value)}
            placeholder="Paste your ME API token"
            required
          />
          {error && <p style={styles.error}>{error}</p>}
          <button style={styles.button} type="submit" disabled={loading}>
            {loading ? 'Authenticating…' : 'Sign In'}
          </button>
        </form>
        <p style={styles.hint}>Use the same credentials as PRIMO</p>
      </div>
    </div>
  );
}

const styles = {
  container: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: '#0E2841',
  },
  card: {
    background: '#fff',
    borderRadius: 12,
    padding: '48px 40px',
    width: 380,
    boxShadow: '0 8px 32px rgba(0,0,0,0.2)',
  },
  logo: {
    textAlign: 'center',
    marginBottom: 32,
  },
  logoText: {
    display: 'block',
    fontSize: 42,
    fontWeight: 800,
    color: '#0E2841',
    letterSpacing: 6,
  },
  logoSub: {
    display: 'block',
    fontSize: 13,
    color: '#156082',
    letterSpacing: 3,
    textTransform: 'uppercase',
    marginTop: 4,
  },
  label: {
    display: 'block',
    fontSize: 13,
    fontWeight: 600,
    color: '#0E2841',
    marginBottom: 8,
    marginTop: 16,
  },
  input: {
    width: '100%',
    padding: '12px 14px',
    border: '1.5px solid #E8E8E8',
    borderRadius: 8,
    fontSize: 14,
    outline: 'none',
    boxSizing: 'border-box',
  },
  button: {
    width: '100%',
    padding: '13px',
    background: '#156082',
    color: '#fff',
    border: 'none',
    borderRadius: 8,
    fontSize: 15,
    fontWeight: 600,
    cursor: 'pointer',
    marginTop: 24,
  },
  error: {
    color: '#E97132',
    fontSize: 13,
    marginTop: 12,
    marginBottom: 0,
  },
  hint: {
    textAlign: 'center',
    fontSize: 12,
    color: '#aaa',
    marginTop: 16,
  },
};
